var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "section-invert reverse-sm", attrs: { id: "menttum" } },
    [
      _vm.$uiHelpers.isMobile
        ? _c("b-col", { attrs: { md: "12", lg: "6" } }, [
            _c("div", { staticClass: "col-bg ml-lg-auto" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "content my-auto", attrs: { md: "12", lg: "6" } },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("menttum.title")))]),
          _vm._v(" "),
          _c("p", { staticClass: "text-info text-section-one" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("menttum.subtitle")) + "\n    ")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-info text-section-two" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("menttum.subtitle2")) + "\n    ")
          ]),
          _vm._v(" "),
          _c(
            "base-button",
            {
              staticClass: "btn-more-info-white",
              staticStyle: { color: "white" },
              attrs: {
                white: "",
                outline: "",
                href: "/opensaludprime/bienestar"
              }
            },
            [
              _c("span", { staticStyle: { color: "white" } }, [
                _vm._v(_vm._s(_vm.$t("more-info-btn")))
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.$uiHelpers.isMobile
        ? _c("b-col", { attrs: { md: "12", lg: "6" } }, [
            _c("div", { staticClass: "col-bg ml-lg-auto" })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eacd438", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eacd438","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Menttum.vue
// module id = 4147
// module chunks = 36